module.exports = __webpack_public_path__ + "static/media/email-match-welcome.a0c92d7b.svg";